import { Divider, Form, Radio } from 'antd';

import type { DayOfWeek } from 'app/typings/core/common/enum/dayOfWeek';

import styles from '../RoomDiscount.module.scss';
import type { DefaultDiscountMode } from '../hooks/useRoomDiscountLogic';

import { ConstantDiscountRow } from './ConstantDiscountRow';
import { RoomDiscountDaysTable } from './RoomDiscountDaysTable';

type DefaultDiscountSectionProps = {
  currencyFormatter: (value: number) => string;
  formRoomPrice?: number | null;
  discountMode: DefaultDiscountMode;
  defaultNightRoomDiscount?: number | null;
  defaultNightRoomDiscountDays?: Partial<Record<DayOfWeek, number>> | null;
  getDayBasePrice: (day: DayOfWeek) => number | null | undefined;
  onDiscountModeChange: (mode: DefaultDiscountMode) => void;
};

export const DefaultDiscountSection = ({
  currencyFormatter,
  formRoomPrice,
  discountMode,
  defaultNightRoomDiscount,
  defaultNightRoomDiscountDays,
  getDayBasePrice,
  onDiscountModeChange,
}: DefaultDiscountSectionProps) => (
  <div className={styles.wrapper}>
    <div className={styles.discountHeader}>
      <p className={styles.discountTitle}>DEFAULT DISCOUNT</p>
    </div>
    <div className={styles.discountModeWrapper}>
      <Form.Item noStyle name="defaultDiscountMode">
        <Radio.Group
          className={styles.discountModeRadios}
          onChange={(e) =>
            onDiscountModeChange(e.target.value as DefaultDiscountMode)
          }
        >
          <Radio value="CONSTANT">Same every day</Radio>
          <Radio value="DAILY">Depends on the day</Radio>
        </Radio.Group>
      </Form.Item>
      <Divider className={styles.divider} />
      {discountMode === 'DAILY' ? (
        <div className={styles.daysWrapper}>
          <span>
            Apply a discount to all rooms within packages for each day of the
            week:
          </span>
          <RoomDiscountDaysTable
            currencyFormatter={currencyFormatter}
            defaultNightRoomDiscountDays={defaultNightRoomDiscountDays}
            getDayBasePrice={getDayBasePrice}
          />
        </div>
      ) : (
        <ConstantDiscountRow
          currencyFormatter={currencyFormatter}
          formRoomPrice={formRoomPrice}
          defaultNightRoomDiscount={defaultNightRoomDiscount}
        />
      )}
    </div>
  </div>
);
